module.exports = __webpack_public_path__ + "img/email-success.8fa9fff9.gif";